var map = {
	"./animal-from-the-sea.png": 3916,
	"./animals-of-the-forest.png": 5097,
	"./colouring-stickers.png": 33565,
	"./dialogue-cards.png": 60951,
	"./facial-expression.png": 10190,
	"./flipover-illustrations.png": 66904,
	"./massage-history.png": 19587,
	"./massage-history2.png": 81530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63872;